import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Container from '@material-ui/core/Container';

import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import IconButton from '@material-ui/core/IconButton';
import LoadedComponent from '../loadedComponent/LoadedComponent';
import useConfluencePage from '../../hooks/useConfluencePage';
import AccessDenied from '../auth/AccessDenied';
import useAuth from '../auth/context/auth';
import { BASE_URL } from '../../apis/confluence';
import { ADMINISTRATOR } from '../../constants/userRoles';
import '../../css/confluence.css';

const ConfluencePage = ({ pageName, hasAccess }) => {
  const { html, pageTitle, loading, pageEditLink } = useConfluencePage({
    pageName,
    hasAccess,
  });

  const { userAttributes: { profile: userRoles } } = useAuth();

  const getUrl = useMemo(() => {
    return `${BASE_URL}${pageEditLink}`;
  }, [pageEditLink]);

  const isAdmin = useMemo(() => {
    return userRoles && userRoles.includes(ADMINISTRATOR);
  }, [userRoles]);

  return (
    <Container>
      {hasAccess ? (
        <LoadedComponent loading={loading} hasData={html !== undefined}>
          <>
            <h2>
              {pageTitle}
              {isAdmin && (
                <IconButton
                  aria-label="Edit Confluence"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  color="inherit"
                  href={getUrl}
                  target="_blank"
                >
                  <EditOutlinedIcon />
                </IconButton>
              )}
            </h2>

            <div
              id="confluence"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: html,
              }}
            />
          </>
        </LoadedComponent>
      ) : (
          <AccessDenied />
        )}
    </Container>
  );
};

ConfluencePage.defaultProps = {
  hasAccess: true,
};

ConfluencePage.propTypes = {
  pageName: PropTypes.string.isRequired,
  hasAccess: PropTypes.bool,
};

export default ConfluencePage;
